"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _itemContext = require("./itemContext");
Object.keys(_itemContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _itemContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _itemContext[key];
    }
  });
});
